import React from 'react';
import Win98Dialog from './Win98Dialog';
import './WinNotification.css';

const WinNotification = ({ winData, onClose }) => {
  if (!winData) return null;

  const { rank, prize, username } = winData;
  const rankEmoji = rank === 1 ? '🥇' : rank === 2 ? '🥈' : '🥉';
  const rankText = rank === 1 ? '1st Place' : rank === 2 ? '2nd Place' : '3rd Place';

  return (
    <Win98Dialog
      title="Congratulations!"
      icon="🎉"
      onClose={onClose}
      width={500}
      buttons={[
        {
          label: 'Awesome!',
          onClick: onClose
        }
      ]}
    >
      <div className="win-celebration">
            <div className="win-emoji-large">{rankEmoji}</div>
            <h3 className="win-title">You Won {rankText}!</h3>
            <p className="win-username">@{username}</p>
          </div>

          <div className="win-prize-info win98-bevel-inset">
            <div className="win-prize-amount">
              <span className="win-prize-label">Prize Amount:</span>
              <span className="win-prize-value">{parseFloat(prize).toFixed(8)} DOGE</span>
            </div>
            <p className="win-prize-note">
              Your winnings will be sent to your payout address once verified!
            </p>
          </div>

          <div className="win-message">
            <p>🏆 Amazing work! Your message was one of the top {rank === 1 ? '3' : rank === 2 ? '3' : '3'} most upvoted today!</p>
            <p>Check your Settings page to view your payout history.</p>
      </div>
    </Win98Dialog>
  );
};

export default WinNotification;

